import React from "react"
import Button from "@irati/ui/src/Button"
import Flex from "@irati/ui/src/Flex"
import {ButtonLink} from "@irati/ui/src/Link"
import {Body, H1, H5} from "@irati/ui/src/Typography"
import theme from "@irati/ui/src/global/theme"
import FormattedMessage, {injectIntl} from "@irati/utils/lang"
import {InjectIntlProps} from "@irati/utils/lang/injectIntl"
import globalImage from "@irati/ui/images/world.svg"
import cartImage from "@irati/ui/images/cart.svg"
import {StyledMarkdown, ImageContainer} from "./styled"

interface Props extends InjectIntlProps {
  onHide?: () => void
}

const NewRewardWalletContent: React.FC<Props> = (props) => {
  const {onHide, formatMessage} = props
  return (
    <>
      <Flex direction="column" gap=".5rem" marginTop={4} marginBottom={4}>
        <H1 color={theme.colors.greys.white}>
          <FormattedMessage id="wallet.newRewardAlert.title" />
        </H1>
        <Body color={theme.colors.greys.white}>
          <FormattedMessage id="wallet.newRewardAlert.subtitle" />
        </Body>
      </Flex>
      <Flex gap="2rem" wrap="wrap-reverse">
        <Flex direction="column" flex="1 1 45%">
          <Flex gap=".75rem">
            <ImageContainer>
              <img src={globalImage} alt="World icon" />
            </ImageContainer>
            <div>
              <H5 color={theme.colors.greys.white}>
                <FormattedMessage id="wallet.newRewardAlert.firstSection.title" />
              </H5>
              <Body color={theme.colors.greys.white}>
                <FormattedMessage id="wallet.newRewardAlert.firstSection.message" />
              </Body>
            </div>
          </Flex>
          <Flex gap=".75rem" marginTop={4}>
            <ImageContainer>
              <img src={cartImage} alt="Cart icon" />
            </ImageContainer>
            <div>
              <H5 color={theme.colors.greys.white}>
                <FormattedMessage id="wallet.newRewardAlert.secondSection.title" />
              </H5>
              <Body color={theme.colors.greys.white}>
                <StyledMarkdown source={formatMessage({id: "wallet.newRewardAlert.secondSection.message"})} />
              </Body>
            </div>
          </Flex>
          <Flex marginTop={4} gap="1rem">
            <ButtonLink full href="https://www.perkbox.com/resources/product/rewarding-with-global-reward" primary target="_blank">
              <FormattedMessage id="platform.ui.banner.cta.text" />
            </ButtonLink>
            {onHide && (
              <Button full onClick={onHide} inverted>
                <FormattedMessage id="platform.ui.banner.cta.gotIt" />
              </Button>
            )}
          </Flex>
          <Body color={theme.colors.greys.white} marginTop={4} small>
            <FormattedMessage id="wallet.newRewardAlert.upgradeNowHint" />
          </Body>
        </Flex>
        <Flex minWidth="320px" minHeight="200px" flex="1 1 50%">
          <iframe
            src="//player.vimeo.com/video/726081820"
            scrolling="no"
            width="100%"
            height="100%"
            title="New Reward Wallet intro"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            frameBorder="0"
            allowFullScreen />
        </Flex>
      </Flex>
    </>
  )
}
export default injectIntl(NewRewardWalletContent)
